export default "__VITE_ASSET__f638bd72__"